export default __webpack_public_path__ + "static/Fellix-ExtraBold-bbb8710809d083a3f75e985c9e92c84f.otf";